const data = {
  testimonials: [
    {
      id: 1,
      description:
        'Microsoft PowerApps',
      designation: 'Une réalisation ultra-rapide et sécurisée grâce à la plateforme low-code de Microsoft',
    },
    {
      id: 2,
      description:
        'Microsoft Office 365',
      designation: 'Une solution au coeur de vos outils du quotidien',
    },

    {
      id: 3,
      description:
        'Salesforce',
      designation: 'Une connection native au CRMs leader du marché',
    },

    {
      id: 4,
      description:
        'Microsoft Dynamics 365',
      designation: 'Une connection native au CRMs leader du marché',
    },

    {
      id: 5,
      description:
        'Microsoft Teams',
      designation: 'Restez en contact avec votre équipe à tout moment !',
    },
  ],
};
export default data;
